/* 🤖 this file was generated by svg-to-ts*/
export const icoEnvelopeFilled: {
  name: 'envelope-filled';
  data: string;
} = {
  name: 'envelope-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.085 6.42l9.246 8.323.095.076a1 1 0 001.098.033l.11-.078L22 7.109V17a2 2 0 01-2 2H4a2 2 0 01-2-2V7a2 2 0 01.085-.58zM20 5c.387 0 .749.11 1.055.3l-9.024 7.382-8.48-7.631C3.694 5.018 3.844 5 4 5h16z" fill="#909090"/></svg>`
};
